import { useTranslation } from 'react-i18next'

import { Box, Container, Stack, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreateGroupForm from './containers/CreateGroupForm'

export function CreateGroupPage() {
  const { t } = useTranslation()

  return (
    <Box>
      <Container maxWidth="xl">
        <Stack spacing={1} sx={{ pl: '30px', pr: '30px' }}>
          <Typography variant="h2" sx={{ mt: '30px', mb: '30px' }}>
            {t('page.admin.createGroup.title')}
          </Typography>
        </Stack>
      </Container>
      <PageContainer sx={{ '& > div': { paddingTop: 0 } }}>
        <CreateGroupForm />
      </PageContainer>
    </Box>
  )
}

export default CreateGroupPage
